<template>
  <div>
    <div class="catalog-view__subtitle catalog-view__subtitle-main">Референсы на замену <span v-if="references.length > 1">{{ references.length }}</span></div>
    <div class="catalog-view__table catalog-view__table-references">
      <table>
        <thead>
        <tr>
          <th>Референс</th>
          <th>Кол-во для замены</th>
          <th>Дата замены</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(reference, key) in references" :key="key">
          <td>
            <a :href="'/catalog/view/' + reference.reference" class="catalog-view__link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 15L18 6L9 6L9 8L16 8L16 15L18 15Z" fill="#00AC86" />
                <path d="M17 7L6 18" stroke="#00AC86" stroke-width="2" />
              </svg>
              <span>{{ reference.reference }}</span>
            </a>
          </td>
          <td>{{ reference.quantity_new }}</td>
          <td>{{ reference.substitution_beginning }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'replacement-reference',
  props: {
    references: {
      type: Array
    }
  },
  methods: {

  }
}
</script>